<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->

<ng-container *ngIf="ready | async">
  <div class="login-page-wrapper">
    <div class="inner-wrapper" [ngClass]="{'inner-wrapper': true, 'inner-wrapper-large': (outerBanner | async),
                'inner-wrapper-small': !(outerBanner | async)}">
      <div class="indirect-login-heading" *ngIf="!(outerBanner | async)"></div>
      <mat-toolbar class="toolbar mat-elevation-z0" *ngIf="outerBanner | async">
        <mat-toolbar-row class="title">
          <div *ngIf="partnerId === cigentPartner || partnerId === doqubizPartner || partnerId === digistorPartner"
               class="img-banner">
            <img class="cigent-logo" src="assets/Cigent_Logo_Light_R.webp" alt="Cigent Logo" />
            <img class="cigent-box" src="assets/cigent-box.jpg"  alt="Digital art" />
          </div>
          <div *ngIf="partnerId === lenovoPartner" class="img-banner">
            <div class="lenovo-logo-wrapper">
              <span class="lenovo-logo"></span>
              <div>
                <span class="data-defense">
                  Data Defense <span class="powered-by-cigent">powered by Cigent</span>
                </span>
              </div>
            </div>
            <img class="cigent-box" src="assets/cigent-box.jpg" alt="Digital art" />
          </div>
          <div *ngIf="partnerId === kanguruPartner" class="img-banner">
            <div class="kanguru-logo-wrapper">
              <span class="kanguru-logo"></span>
              <div>
                <span class="data-defense"><span class="powered-by-cigent">Powered by Cigent</span>
                </span>
              </div>
            </div>
            <img class="cigent-box" src="assets/cigent-box.jpg" alt="Digital art" />
          </div>
          <div *ngIf="partnerId === vrsPartner" class="img-banner">
            <div class="vrs-logo-wrapper">
              <span class="vrs-logo"></span>
              <div>
                <span class="data-defense"><span class="powered-by-cigent">Powered by Cigent</span>
                </span>
              </div>
            </div>
            <img class="cigent-box" src="assets/cigent-box.jpg" alt="Digital art" />
          </div>
        </mat-toolbar-row>
      </mat-toolbar>
      <div class="flip-container" [ngClass]="{'flip': !cigentLogin}">
        <div class="flipper">
          <div class="front">
            <mat-card appearance="raised" class="form-container mat-elevation-z1">
              <mat-card-content>
                <div class="login-wrapper">
                  <div class="inner-banner-container" *ngIf="!(outerBanner | async)">
                    <div *ngIf="partnerId !== lenovoPartner" class="inner-banner-logo-container">
                      <img class="inner-banner-logo" src="assets/Cigent_Logo_Dark_R@4x.png" alt="Company Logo">
                    </div>
                    <div *ngIf="partnerId === lenovoPartner" class="inner-banner-logo-container">
                      <img class="inner-banner-lenovo-logo" src="assets/lenovologo-small-red.png" alt="Company Logo">
                    </div>
                    <div class="inner-banner-label">{{ 'IV_ACCOUNT' | translate }}</div>
                  </div>
                  <h1 *ngIf="!showPasswordUpdateForm">{{fHeader}}</h1>
                  <h1 *ngIf="showPasswordUpdateForm">{{fChangePassword}}</h1>
                </div>
                <app-password *ngIf="showPasswordUpdateForm"
                              [mode]="'DEVICE_UPDATE'"
                              [username]="form.value.username"
                              [password]="form.value.password"
                              [stayLoggedIn]="stayLoggedIn"
                              [deviceToken]="deviceToken"
                              [showBestPractices]="false"
                              [secondFactor]="form.value.second_factor"></app-password>
                <form [formGroup]="form" (ngSubmit)="onSubmit()" *ngIf="!showPasswordUpdateForm">

                  <div class="form-wrapper">
                    <div class="login-error" *ngIf="loginError">
                      <span tabindex="1" class="error-message">{{fInvalid}}</span>
                    </div>
                    <div class="login-error" *ngIf="deactivatedError">
                      <span tabindex="1" class="error-message">{{fDeactivated}}</span>
                    </div>
                    <div class="login-error" *ngIf="domainError">
                      <span tabindex="1" class="error-message">{{'ERROR_LOGIN_DOMAIN' | translate}}</span>
                    </div>

                    <div class="login-error" *ngIf="!loginError && !deactivatedError && timedOut">
                      <span tabindex="1" class="error-message">{{'sign-in.error.login-timed-out' | translate}}</span>
                    </div>
                    <span *ngIf="showLogin">
                        <mat-form-field class="email-form-field" appearance="outline">
                          <mat-label>{{fEmailLabel}}</mat-label>
                          <input id="username" matInput placeholder="{{fEmail}}" appAutofocus formControlName="username"
                                 [value]="usernameParam">
                        </mat-form-field>
                        <mat-form-field class="password-form-field" appearance="outline">
                          <mat-label>{{fPassword}}</mat-label>
                          <span style="display: flex;">
                            <input id="password" matInput type="password" placeholder="{{fPassword}}"
                               (input)="tooltip?.show()" formControlName="password"
                               (capsLock)="onCapsLockChanged($event)" (focus)="passwordFocus()" (blur)="passwordBlur()">
                            @if (capsOn) {
                              <mat-icon matIconSuffix class="mdi mdi-apple-keyboard-caps caps-on-icon" #tooltip="matTooltip"
                                matTooltip="{{'CAPS_LOCK_IS_ON' | translate}}" matTooltipPosition="right"></mat-icon>
                            }
                          </span>
                        </mat-form-field>
                    </span>

                    <span *ngIf="show2fa">
                      <div style="padding-bottom: 10px;">
                        <mat-label><b>{{f2FAA}}</b>{{f2FAB}}</mat-label>
                      </div>
                      <mat-form-field class="twofa-form-field" appearance="outline">
                        <input matInput type="second_factor" appAutofocus placeholder="{{f2FAC}}" aria-label="2FA" autocomplete="off" formControlName="second_factor" required />
                      </mat-form-field>
                      <div class="recovery-code" style="padding-top: 10px;">
                        <div class="recovery-use-warning">
                          {{fRecovery}}
                        </div>
                      </div>
                    </span>
                  </div>
                  <mat-grid-list cols="1" rowHeight="65px">
                    <mat-grid-tile>
                      <div>
                        <button id="sign-in" class="log-in-btn" color="primary" mat-flat-button style="float: right">{{fSignIn}}</button>
                      </div>
                    </mat-grid-tile>
                    <mat-grid-tile *ngIf="showMSLogin || showOktaLogin">
                      <h2>or</h2>
                    </mat-grid-tile>
                    <mat-grid-tile *ngIf="showMSLogin">
                      <div>
                        <img [src]="(theme | async) === 'dark' ? msButtonDarkPath : msButtonLightPath"
                             (click)="showMSLoginForm()" alt="Sign in with Microsoft button" />
                      </div>
                    </mat-grid-tile>
                    <mat-grid-tile *ngIf="showOktaLogin">
                      <div>
                          <img [src]="(theme | async) === 'dark' ? oktaButtonDarkPath : oktaButtonLightPath"
                               (click)="showOktaLoginForm($event)" alt="Sign in with okta"/>
                      </div>
                    </mat-grid-tile>
                  </mat-grid-list>
                </form>
                <div class="login-box-footer">
                  <div class="reset-password">
                    <a routerLink="/reset" routerLinkActive="active">{{fForgot}}</a>
                  </div>
                  <div *ngIf="showStayLoggedIn && !showPasswordUpdateForm">
                    <mat-checkbox *ngIf="partnerId !== lenovoPartner" color="primary" [(ngModel)]="stayLoggedIn">{{'LI_STAY_LOGGED_IN' | translate}}</mat-checkbox>
                    <mat-checkbox *ngIf="partnerId === lenovoPartner" color="primary" [(ngModel)]="stayLoggedIn">{{'LI_STAY_LOGGED_IN_LENOVO' | translate}}</mat-checkbox>
                  </div>
                </div>
              </mat-card-content>
            </mat-card>
          </div>
          <div class="back">
              @if (!cigentLogin) {
                  @if (thirdPartyAuth == 'ms') {
                      <app-login-ms
                              [showMsLogin]="!cigentLogin"
                              [authenticateCigentUser]="true"
                              (toggleSigInClick)="toggleSigIn()"></app-login-ms>
                  } @else if (thirdPartyAuth == 'okta') {
                      <app-login-okta (toggleSigInClick)="toggleSigIn()"></app-login-okta>
                  }
              }
          </div>
        </div>
      </div>

      <div class="footer">
        <div>
          <span *ngIf="partnerId === lenovoPartner; else cigentCopyright">
            <a href="{{LenovoPrivacyURL}}" rel="noopener noreferrer" target="_blank">Lenovo Privacy Statement</a>
          </span>
          <ng-template #cigentCopyright>
            <span>&copy; {{ currentYear }} Cigent Technology Inc.</span>
          </ng-template>
        </div>
        <div>{{'ADO_EMAIL' | translate}} <a href="mailto:support@cigent.com" target="_blank" rel="noopener noreferrer">support&#64;cigent.com</a> {{'OR_VISIT_TEXT' | translate}} <a href="https://support.cigent.com/support/home" target="_blank" rel="noopener noreferrer" title="Cigent Support">{{'CIGENT_SUPPORT_LINK_TEXT' | translate}}</a></div>
        <div>
          <span *ngIf="partnerId === lenovoPartner; else cigentTermsAndPolicies">
            <a href="{{CigentPoliciesURL}}" rel="noopener noreferrer" target="_blank">Cigent Privacy Policies</a>
          </span>
          <ng-template #cigentTermsAndPolicies>
            <span>Cigent's <a href="{{CigentTermsURL}}" rel="noopener noreferrer" target="_blank">{{'SUBF_TERMS' | translate}}</a> {{'SUBF_AND' | translate}} <a href="https://www.cigent.com/policies" rel="noopener noreferrer" target="_blank">{{'DIV_TOUD' | translate}}</a></span>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
</ng-container>
